module.exports = __webpack_public_path__ + "img/buttons.ef6a8420.svg";